/* tslint:disable: no-console */
export default class Logger {
  public static log(params: any) {
    return console.log(params);
  }

  public static warn(params: any) {
    if (process.env.NODE_ENV !== 'production') {
      console.error(params);
    } else {
      console.warn(params);
    }
  }

  public static error(params: any) {
    return console.error(params);
  }
}
